/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HighRiskServiceReviewResponse
 */
export interface HighRiskServiceReviewResponse {
    /**
     * 
     * @type {string}
     * @memberof HighRiskServiceReviewResponse
     */
    highRiskId?: string | null;
}

/**
 * Check if a given object implements the HighRiskServiceReviewResponse interface.
 */
export function instanceOfHighRiskServiceReviewResponse(value: object): value is HighRiskServiceReviewResponse {
    return true;
}

export function HighRiskServiceReviewResponseFromJSON(json: any): HighRiskServiceReviewResponse {
    return HighRiskServiceReviewResponseFromJSONTyped(json, false);
}

export function HighRiskServiceReviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HighRiskServiceReviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'highRiskId': json['highRiskId'] == null ? undefined : json['highRiskId'],
    };
}

export function HighRiskServiceReviewResponseToJSON(json: any): HighRiskServiceReviewResponse {
    return HighRiskServiceReviewResponseToJSONTyped(json, false);
}

export function HighRiskServiceReviewResponseToJSONTyped(value?: HighRiskServiceReviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'highRiskId': value['highRiskId'],
    };
}

